import SectionTabs from '../../components/SectionTabs';
import { SUBMIT_TABS } from '../../lib/section-tabs';
import DropZone from '../../components/DropZone';

export default function AdminSubmitPage() {
  return (
    <SectionTabs ariaLabel="Submit sections" items={SUBMIT_TABS}>
      <h1>Submit anything</h1>
      <p className="text-muted">
        Drop a screenshot or flyer, paste a URL (Instagram, Facebook, Eventbrite, an event page,
        or a venue homepage), or paste raw event text. Choose <em>Venue</em> to register a
        location instead of a single event — the backend will create or match the venue and
        scan its website for events.
      </p>
      <DropZone />
    </SectionTabs>
  );
}
